<script setup>
// The interactive menu only renders its dropdowns on hover (v-if on activeIndexLv1), so none of
// the submenu links exist in the server-rendered HTML and crawlers never discover the pages behind
// them. This renders the same menu data as plain links, always, and hides it from users:
// aria-hidden + tabindex -1 keep it out of the accessibility tree and the tab order, the real
// menu stays the only interactive one.
defineProps({
  menu: { type: Array, default: () => [] },
})

const localePath = useLocalePath()

// Internal, real pages only: external links (investor site, training site) aren't what this is
// for, and label-only folders such as /inspection-services/industries 404.
function hrefFor(entry) {
  const link = entry?.link
  if (!link?.startsWith('/') || isLabelOnlyPath(link))
    return null

  return localePath({ path: link })
}
</script>

<template>
  <nav class="sr-only" aria-hidden="true" data-crawlable-menu>
    <ul>
      <li v-for="item in menu" :key="item._uid">
        <NuxtLink v-if="hrefFor(item)" :to="hrefFor(item)" tabindex="-1">
          {{ item.label }}
        </NuxtLink>
        <span v-else>{{ item.label }}</span>
        <ul v-if="item.submenu?.length">
          <li v-for="lv1 in item.submenu" :key="lv1._uid">
            <NuxtLink v-if="hrefFor(lv1)" :to="hrefFor(lv1)" tabindex="-1">
              {{ lv1.label }}
            </NuxtLink>
            <span v-else-if="lv1.label">{{ lv1.label }}</span>
            <ul v-if="lv1.submenu?.length">
              <li v-for="lv2 in lv1.submenu" :key="lv2._uid">
                <NuxtLink v-if="hrefFor(lv2)" :to="hrefFor(lv2)" tabindex="-1">
                  {{ lv2.label }}
                </NuxtLink>
                <span v-else-if="lv2.label">{{ lv2.label }}</span>
                <ul v-if="lv2.submenu?.length">
                  <li v-for="lv3 in lv2.submenu" :key="lv3._uid">
                    <NuxtLink v-if="hrefFor(lv3)" :to="hrefFor(lv3)" tabindex="-1">
                      {{ lv3.label }}
                    </NuxtLink>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
